export enum FacilityTypes {
  ALL = "",
  PARTNER = "partner",
  PERSONAL = "personal",
}

export const FACILITY_PREFIX = "FACILITY-";

export const LOAD_CUSTOM_FILTER_FACILITIES = "loadingCustomFilterFacilities";

export const PERSONAL_FACILITY = "PERSONAL";
export const ALL_FACILITY = "ALL_CS";
export const ALL_CARE_SITES = "*";
export const ALL = "ALL";
export const SYSTEM = "SYSTEM";

export const ALL_FACILITIES_ID = "*";

export const All = { id: ALL, title: "- All -" };
const System = { id: SYSTEM, title: "- System -" };
export const All_Fac = { id: ALL_FACILITY, title: "- All Care Sites -" };
export const Personal = { id: PERSONAL_FACILITY, title: "- Personal -" };

export const CustomFacilities = [All, All_Fac, Personal, System];

export const ALL_FACILITIES_SYNONYM = "*";
